// Quick-Assessment topic pre-selection (2026-02).
//
// One shared mechanism used by:
//   • Landing.jsx  — "Try a Quick Assessment" gold-pill row (public, unauth'd)
//   • Signup.jsx   — persists the choice through authentication
//   • Dashboard.jsx — shows the pre-selected topic + a continue-CTA after login
//
// Design goals:
//   • Public visitors never reach /quick-assessment/new anonymously.
//   • Choosing a topic on Landing routes to /signup?topic=<slug>, the choice
//     is echoed on the signup page, persisted in localStorage before submit,
//     and reappears on the Dashboard as a preselected callout post-auth.
//   • Slugs are the ONLY strings crossing surfaces — labels come from this
//     file so copy stays consistent.

const STORAGE_KEY = "pa_selected_qa_topic";

export const QA_TOPICS = [
  { slug: "implant-abutment-selection", label: "Implant abutment selection" },
  { slug: "all-on-x-material-choice", label: "All-on-X material choice" },
  { slug: "rpd-design-check", label: "RPD design check" },
  { slug: "crown-margin-question", label: "Crown margin question" },
];

export function topicLabel(slug) {
  const t = QA_TOPICS.find((x) => x.slug === slug);
  return t ? t.label : null;
}

/** Read the `?topic=<slug>` query string from any Location-like source. */
export function readTopicFromSearch(search) {
  try {
    const params = new URLSearchParams(search || "");
    const slug = params.get("topic");
    if (!slug) return null;
    return topicLabel(slug) ? slug : null;
  } catch (_) { return null; }
}

/** Save the topic slug so it survives the signup / disclaimer / login hop. */
export function persistTopic(slug) {
  try {
    if (slug && topicLabel(slug)) {
      window.localStorage.setItem(STORAGE_KEY, slug);
    }
  } catch (_) { /* localStorage best-effort */ }
}

/** Return the previously persisted topic slug, or null. */
export function readPersistedTopic() {
  try {
    const slug = window.localStorage.getItem(STORAGE_KEY);
    return slug && topicLabel(slug) ? slug : null;
  } catch (_) { return null; }
}

/** Clear once the user has acted on the topic (or explicitly dismissed it). */
export function clearPersistedTopic() {
  try { window.localStorage.removeItem(STORAGE_KEY); } catch (_) { /* no-op */ }
}
